var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / topics / Shazam Topic Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full-pages-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discoveries-FP--DT---track-no-filter-Copy-2",
    transform: "translate(-194.000000, -511.000000)",
    fill: "#001247",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(160.000000, 475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-topics-/-shazam",
    transform: "translate(32.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2.62831532 C23.3849775,2.62831532 29.3716847,8.61502247 29.3716847,16 C29.3716847,20.9443087 26.6644356,25.4126333 22.4041539,27.7410677 C20.5780089,28.7391376 18.5408372,29.2989859 16.424322,29.3650682 L16,29.3716847 L16,27.9441048 C18.0274961,27.9441048 19.9802728,27.4389427 21.719502,26.4883762 C25.5261979,24.4078467 27.9441048,20.4170824 27.9441048,16 C27.9441048,9.40345307 22.5965469,4.0558952 16,4.0558952 C11.388782,4.0558952 7.25164903,6.69217386 5.26233693,10.7623826 C4.53296201,12.2547116 4.12215139,13.8862524 4.06326558,15.5763125 L4.0558952,16 L2.62831532,16 C2.62831532,13.9406799 3.09470642,11.9463544 3.97975091,10.1355195 C6.2063295,5.57985437 10.8382031,2.62831532 16,2.62831532 Z M21.7961105,13.6754386 C23.8574368,15.67079 23.8574368,18.9058937 21.7961105,20.901245 L18.2414805,24.3421053 L17.1750915,23.3098472 L20.7297215,19.868987 C22.2020975,18.443736 22.2020975,16.1329476 20.7297215,14.7076967 C19.2573456,13.2824457 16.8701525,13.2824457 15.3977765,14.7076967 L13.9759245,16.0840407 L12.9095355,15.0517827 L14.3313875,13.6754386 C16.3927139,11.6800872 19.7347842,11.6800872 21.7961105,13.6754386 Z M13.44273,8.34210526 L14.509119,9.37436333 L10.954489,12.8152235 C9.48211306,14.2404745 9.48211306,16.5512629 10.954489,17.9765139 C12.426865,19.4017648 14.8140581,19.4017648 16.286434,17.9765139 L17.708286,16.6001698 L18.774675,17.6324278 L17.352823,19.0087719 C15.2914967,21.0041233 11.9494264,21.0041233 9.88810002,19.0087719 C7.82677368,17.0134206 7.82677368,13.7783168 9.88810002,11.7829655 L13.44273,8.34210526 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.2bfc7920.svg";
export { ForwardRef as ReactComponent };